
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import * as modals from "@/lib/modals";

@Component({
  name: modals.columnVisabilityModal
})
export default class ColumnVisibilityModal extends Vue {
  @Prop({ default: [] })
  defaultFields: Array<any>;

  @Prop({ default: [] })
  visibleFields: Array<any>;

  @Ref() readonly tableFields: any;

  created() {
    this.$nextTick(() => {
      this.tableFields.show();
    });
  }

  showAllFields() {
    this.$emit("resetFilterFields");
  }

  resetModal() {
    this.$emit("closeModal");
  }

  handleOk(bvModalEvt) {
    // Prevent modal from closing
    bvModalEvt.preventDefault();
    // Trigger submit handler
    this.handleSubmit();
  }

  handleSubmit() {
    this.$emit("closeModal");
    // Hide the modal manually
    // this.$nextTick(() => {
    //   this.tableFields.hide();
    // });
  }
}
